/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisterRequest as ModelsRegisterRequest } from '../../models/models/register-request';
import { SuccessResponse as ModelsSuccessResponse } from '../../models/models/success-response';

export interface ApiV1AuthRegisterPost$Params {
  
    /**
     * Registration request
     */
    body: ModelsRegisterRequest
}

export function apiV1AuthRegisterPost(http: HttpClient, rootUrl: string, params: ApiV1AuthRegisterPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1AuthRegisterPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsSuccessResponse>;
    })
  );
}

apiV1AuthRegisterPost.PATH = '/api/v1/auth/register';
